import { render } from "./ThemeColor.vue?vue&type=template&id=54ac2b32&scoped=true&lang=pug&bindings={\"themeColor\":\"setup\",\"themeColors\":\"setup\",\"setThemeColor\":\"setup\"}"
import script from "./ThemeColor.vue?vue&type=script&lang=ts"
export * from "./ThemeColor.vue?vue&type=script&lang=ts"

import "./ThemeColor.vue?vue&type=style&index=0&id=54ac2b32&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-54ac2b32"

export default script